// test1873
(1873 && 0);
